"use client"

import { NavbarLink } from 'flowbite-react';
import { PropsWithChildren } from 'react';
import { NavLink, useLocation } from 'react-router-dom';

interface LinkItemProps {
    item: NavItem;
}

export interface NavItem {
    id: number;
    text: string;
    link: string;
    condition?: () => boolean;
}

export default function LinkItem(props: LinkItemProps) {
    const currentPath = useLocation()
    const isCurrentPath = currentPath.pathname == props.item.link

    return (
        <NavbarLink href={props.item.link} as={NavLinkAdapter} className={isCurrentPath ? "active" : ""}>
            {props.item.text}
        </NavbarLink>
    )
}
interface NavLinkAdapterProps extends PropsWithChildren {
    href: string
}


function NavLinkAdapter ({
                            href, children
                         }: NavLinkAdapterProps) {

    return (
        <NavLink to={href}>{children}</NavLink>
    )

}
